var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#02CB63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 21.25C24.9289 21.25 23.25 22.9289 23.25 25C23.25 27.0711 24.9289 28.75 27 28.75C29.0711 28.75 30.75 27.0711 30.75 25C30.75 22.9289 29.0711 21.25 27 21.25ZM24.75 25C24.75 23.7574 25.7574 22.75 27 22.75C28.2426 22.75 29.25 23.7574 29.25 25C29.25 26.2426 28.2426 27.25 27 27.25C25.7574 27.25 24.75 26.2426 24.75 25Z",
    fill: "#E2FFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15.25C22.1167 15.25 18.25 19.4928 18.25 24.6087C18.25 26.2494 19.0651 28.1814 20.0906 29.9945C21.1328 31.837 22.4629 33.6762 23.629 35.1633L23.6679 35.2129C24.2371 35.9388 24.722 36.5573 25.1922 36.9844C25.7052 37.4504 26.2709 37.7555 27 37.7555C27.7291 37.7555 28.2948 37.4504 28.8078 36.9844C29.278 36.5572 29.7629 35.9388 30.3321 35.2129L30.371 35.1633C31.5371 33.6762 32.8672 31.837 33.9094 29.9945C34.9349 28.1814 35.75 26.2494 35.75 24.6087C35.75 19.4928 31.8833 15.25 27 15.25ZM19.75 24.6087C19.75 20.2157 23.0468 16.75 27 16.75C30.9532 16.75 34.25 20.2157 34.25 24.6087C34.25 25.8352 33.6104 27.4764 32.6037 29.256C31.6137 31.0063 30.3342 32.7794 29.1906 34.2377C28.5717 35.027 28.1641 35.5426 27.7992 35.8741C27.4664 36.1764 27.2442 36.2555 27 36.2555C26.7558 36.2555 26.5336 36.1764 26.2008 35.8741C25.8359 35.5426 25.4283 35.027 24.8094 34.2377C23.6658 32.7794 22.3863 31.0063 21.3963 29.256C20.3896 27.4764 19.75 25.8352 19.75 24.6087Z",
    fill: "#E2FFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4a3f4bfdca89d61ab9e41c051e7c1a3f.svg";
export { ForwardRef as ReactComponent };